<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6" lg="6" class="mb-0 pb-0">
              <el-text-field
                label="Objektas"
                disabled
                v-model="formData.object_title"
              />
            </v-col>
            <v-col cols="12" md="6" lg="6" class="mb-0 pb-0">
              <el-text-field
                label="Rolė objekte"
                disabled
                v-model="formData.role_in_object"
              />
            </v-col>

            <v-col cols="12">
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Atstovų tikrinimas, nepavykus pritaikyti nė vienos taisyklės"
                v-model="formData.check_representatives"
              >
              </el-checkbox>
            </v-col>

            <v-col v-if="formData.check_representatives" cols="12" class="ml-0 pl-0">
              <el-select-table
                title="Teisinės formos, kurioms galimas atstovų patikrinimas"
                elKey="legal_forms_for_manual_check"
                :available-items="jarForms"
                :selected-items="formData.legal_forms_for_manual_check"
                availableTitle="Galimos reikšmės"
                selectedTitle="Pasirinktos teisinės formos"
                item-key="value"
                item-name="text"
                @move-to-selected="moveToSelected"
                @move-to-available="moveToAvailable"
              />
            </v-col>

            <v-col cols="12" class="mb-0 pb-0">
              <el-textarea
                required
                label="Klaidos pranešimas lietuvių kalba"
                v-model="formData.error_message_lt"
                maxlength="500"
              />
            </v-col>

            <v-col cols="12" class="mb-0 pb-0">
              <el-textarea
                required
                label="Klaidos pranešimas anglų kalba"
                v-model="formData.error_message_en"
                maxlength="500"
              />
            </v-col>
          </v-row>

          <v-tabs>
            <v-tab>{{ $t('Vienasmenis atstovavimas') }}</v-tab>
            <v-tab>{{ $t('Kiekybinis atstovavimas') }}</v-tab>
            <v-tab>{{ $t('JA veikia pagal relig. kanonus, statusas') }}</v-tab>
            <v-tab>{{ $t('Užsienio JA atstovavimas') }}</v-tab>
            <v-tab>{{ $t('Taisyklės nėra') }}</v-tab>

            <v-tab-item>
              <SigningPersonRuleFactForm
                :forms="formData.sole_representation_rules"
                :facts="soleFacts"
                representationType="sole-representation"
                :jarForms="jarForms"
                @add-forms="addForms"
                @init-delete-form="initDeleteForm"
                @init-add-fact="initAddFact"
                @init-edit-fact="initEditFact"
                @init-delete-fact="initDeleteFact"
              />
            </v-tab-item>

            <v-tab-item>
              <SigningPersonRuleQuantativeForm
                :katRules="katRules"
                :isQuantitativeRuleOn="formData.is_quantitative_rule_on"
                @update:isQuantitativeRuleOn="changeQuantitativeRuleOn"
              />
            </v-tab-item>

            <v-tab-item>
              <SigningPersonRuleFactForm
                :forms="formData.religion_rules"
                :facts="religionFacts"
                representationType="religion"
                :jarForms="jarForms"
                @add-forms="addForms"
                @init-delete-form="initDeleteForm"
                @init-add-fact="initAddFact"
                @init-edit-fact="initEditFact"
                @init-delete-fact="initDeleteFact"
              />
            </v-tab-item>

            <v-tab-item>
              <SigningPersonRuleFactForm
                :forms="formData.foreign_ja_rules"
                :facts="foreignFacts"
                representationType="foreign"
                :jarForms="jarForms"
                @add-forms="addForms"
                @init-delete-form="initDeleteForm"
                @init-add-fact="initAddFact"
                @init-edit-fact="initEditFact"
                @init-delete-fact="initDeleteFact"
              />
            </v-tab-item>

            <v-tab-item>
              <SigningPersonRuleFactForm
                :forms="formData.no_representation_rules"
                :facts="noRepresentationFacts"
                representationType="no-representation"
                :jarForms="jarForms"
                @add-forms="addForms"
                @init-delete-form="initDeleteForm"
                @init-add-fact="initAddFact"
                @init-edit-fact="initEditFact"
                @init-delete-fact="initDeleteFact"
              />
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>

    <!-- modal  -->
    <ModalDelete
      title="Įrašo šalinimas"
      text="Ar tikrai norite pašalinti šią teisinę formą?"
      v-model="deleteFormModal.show"
      @confirmDelete="deleteForm"
      @close-modal="closeFormDeleteModal"
    />

    <ModalDelete
      title="Įrašo šalinimas"
      text="Ar tikrai norite pašalinti šią taisyklę?"
      v-model="deleteFactModal.show"
      @confirmDelete="deleteFact"
      @close-modal="closeFactDeleteModal"
    />

    <ModalAddFactSignatoryRule
      v-model="addFactModal.show"
      :jarAttributes="jarAttributes"
      :jarFacts="filteredJarFacts"
      :fact="addFactModal.fact"
      @close="closeAddFactModal"
      @add="addFact"
    />
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
import {classifiersGet} from "@/services/classifierService";
import SigningPersonRuleFactForm from './SigningPersonRuleFactForm.vue';
import SigningPersonRuleQuantativeForm from './SigningPersonRuleQuantativeForm.vue'
import jaRepresentationType from '../../../../components/constants/jaRepresentationType';
import ModalDelete from '../../../../components/modals/ModalDelete.vue';
import ModalAddFactSignatoryRule from '../../../../components/modals/ModalAddFactSignatoryRule.vue';

export default {
  components: {  },
  name: 'signingPersonRuleForm',
  mixins: [userRole],
  components: {SigningPersonRuleFactForm, ModalDelete, ModalAddFactSignatoryRule, SigningPersonRuleQuantativeForm},
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: false,
      enumsClassifiers: [],
      katRules: [],
      formData: {
        fact_rules: [],
        quantitative_rules: [],
        sole_representation_rules: [],
        religion_rules: [],
        foreign_ja_rules: [],
        no_representation_rules: [],
      },
      jarFacts: [],
      filteredJarFacts: [],
      jarAttributes: [],
      jarForms: [],
      deleteFormModal: {
        show: false,
        representationType: undefined,
        form: undefined
      },
      deleteFactModal: {
        show: false,
        representationType: undefined,
        form: undefined,
        fact: undefined
      },
      addFactModal: {
        fact: undefined,
        show: false,
        representationType: undefined,
        form: undefined,
      }
    }
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      return 'Redaguoti pasirašančių asmenų ištraukimo taisyklių rinkinį'
    },
    soleFacts() {
      return this.formData.fact_rules.filter((item) => {
        return item.representation_type === 'sole-representation'
      })
    },
    religionFacts() {
      return this.formData.fact_rules.filter((item) => {
        return item.representation_type === 'religion'
      })
    },
    foreignFacts() {
      return this.formData.fact_rules.filter((item) => {
        return item.representation_type === 'foreign'
      })
    },
    noRepresentationFacts() {
      return this.formData.fact_rules.filter((item) => {
        return item.representation_type === 'no-representation'
      })
    },
  },
  created() {
    this.enumsClassifiers = Enums
    this.getData()
  },
  mounted() {},
  beforeDestroy() {
    window.localStorage.setItem('presetCK', '1')
  },
  methods: {
    setEdit(item) {
      return item
    },
    changeQuantitativeRuleOn(value) {
      console.log(value)
      this.formData.is_quantitative_rule_on = value
    },
    back() {
      this.$router.push({ name: 'signingPersonRules' })
    },
    addForms(representationType, forms) {
      const newFormsArray = Array.isArray(forms[0]) ? forms : [forms];
      switch (representationType) {
        case jaRepresentationType.SOLE_REPRESENTATION: {
          const combinedRules = [
            ...newFormsArray,
            ...this.formData.sole_representation_rules
          ]
          let uniqueNumbersArray = Array.from(new Set(combinedRules.flat()));
          this.formData.sole_representation_rules = uniqueNumbersArray.sort((a, b) => a - b);

          break
        }
        case jaRepresentationType.RELIGION: {
          const combinedRules = [
            ...newFormsArray,
            ...this.formData.religion_rules
          ]
          let uniqueNumbersArray = Array.from(new Set(combinedRules.flat()));
          this.formData.religion_rules = uniqueNumbersArray.sort((a, b) => a - b);

          break
        }
        case jaRepresentationType.FOREIGN:{
          const combinedRules = [
            ...newFormsArray,
            ...this.formData.foreign_ja_rules
          ]
          let uniqueNumbersArray = Array.from(new Set(combinedRules.flat()));
          this.formData.foreign_ja_rules = uniqueNumbersArray.sort((a, b) => a - b);

          break
        }
        case jaRepresentationType.NO_REPRESENTATION:{
          const combinedRules = [
            ...newFormsArray,
            ...this.formData.no_representation_rules
          ]
          let uniqueNumbersArray = Array.from(new Set(combinedRules.flat()));
          this.formData.no_representation_rules = uniqueNumbersArray.sort((a, b) => a - b);

          break
        }
        default:
      }
    },
    async getClassifiers() {
      this.enumsClassifiers = Enums
      this.loadDefault = true
      let requiredClassifiers = { classifiers: ['jar-form', 'jar-attribute', 'jar-fact-sub-type'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.jarForms = res.data.classifiers['jar-form']['lt'].sort((a, b) => a.value - b.value)
          this.jarFacts = res.data.classifiers['jar-fact-sub-type']['lt']
          this.jarAttributes = res.data.classifiers['jar-attribute']['lt']
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
      classifiersGet({ classifiers: ['nirvar']})
        .then(res => this.classifiers = res.data.classifiers)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally()
    },
    async getData() {
      await this.getClassifiers()
      this.pageloading = true
      this.$axios
        .get(`signatory-rules/${this.getId}`)
        .then((res) => {
          this.formData = res.data.signatoryRule
          this.katRules = res.data.kat_rules
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          let url = `signatory-rules/${this.getId}`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    moveToSelected(itemToSelect, key) {
      if (!this.formData[key].includes(itemToSelect.value)) {
        this.formData[key].push(itemToSelect.value);
      }

      this.formData[key].sort((a, b) => a - b);
    },
    moveToAvailable(itemToRemove, key) {
      const indexToRemove = this.formData[key].indexOf(itemToRemove.value);
      if (indexToRemove > -1) {
        this.formData[key].splice(indexToRemove, 1);
      }

      this.formData[key].sort((a, b) => a - b)
    },
    initDeleteForm(representationType, form) {
      this.deleteFormModal.representationType = representationType
      this.deleteFormModal.form = form
      this.deleteFormModal.show = true
    },
    closeFormDeleteModal() {
      this.deleteFormModal.representationType = undefined
      this.deleteFormModal.form = undefined
      this.deleteFormModal.show = false
    },
    deleteForm() {
      switch (this.deleteFormModal.representationType) {
        case jaRepresentationType.SOLE_REPRESENTATION:
          this.formData.sole_representation_rules = this.formData.sole_representation_rules.filter((item) => {
            return item !== this.deleteFormModal.form
          })
          break;
        case jaRepresentationType.RELIGION:
          this.formData.religion_rules = this.formData.religion_rules.filter((item) => {
            return item !== this.deleteFormModal.form
          })
          break;
        case jaRepresentationType.FOREIGN:
          this.formData.foreign_ja_rules = this.formData.foreign_ja_rules.filter((item) => {
            return item !== this.deleteFormModal.form
          })
          break;
        case jaRepresentationType.NO_REPRESENTATION:
          this.formData.no_representation_rules = this.formData.no_representation_rules.filter((item) => {
            return item !== this.deleteFormModal.form
          })
          break;
      }

      this.formData.fact_rules = this.formData.fact_rules.filter((item) => {
        return !(String(item.jar_form_code) === String(this.deleteFormModal.form) && String(item.representation_type) === String(this.deleteFormModal.representationType))
      })
      this.closeFormDeleteModal()
    },
    initAddFact(representationType, form) {
      const existingFactIds = new Set(this.formData.fact_rules
        .filter(item  => item.representation_type === representationType && item.jar_form_code == form)
        .map(obj => String(obj.jar_fact_sub_type_id)))
      this.filteredJarFacts = this.jarFacts.filter(jarFact => {
        return !existingFactIds.has(String(jarFact.value))
      })
      this.addFactModal.representationType = representationType
      this.addFactModal.form = form
      this.addFactModal.show = true
    },
    initEditFact(representationType, form, fact)  {
      this.filteredJarFacts = this.jarFacts
      this.addFactModal.fact = { ...fact }
      this.addFactModal.representationType = representationType
      this.addFactModal.form = form
      this.addFactModal.show = true
    },
    closeAddFactModal() {
      this.filteredJarFacts = this.jarFacts
      this.addFactModal.fact = undefined
      this.addFactModal.representationType = undefined
      this.addFactModal.form = undefined
      this.addFactModal.show = false
    },
    addFact(fact) {
      if (!Array.isArray(this.formData.fact_rules)) {
        this.formData.fact_rules = [];
      }
      fact.representation_type = this.addFactModal.representationType
      fact.jar_form_code = this.addFactModal.form

      const existingFactIndex = this.formData.fact_rules.findIndex(
        (item) => item.jar_fact_sub_type_id == fact.jar_fact_sub_type_id
          && item.representation_type === fact.representation_type
          && item.jar_form_code == fact.jar_form_code
      );

      if (existingFactIndex !== -1) {
        this.formData.fact_rules.splice(existingFactIndex, 1, fact);
      } else {
        this.formData.fact_rules.push(fact);
      }

      this.formData.fact_rules.sort((a, b) => a.order_no - b.order_no)
      this.closeAddFactModal()
    },
    initDeleteFact(representationType, form, fact) {
      this.deleteFactModal.representationType = representationType
      this.deleteFactModal.form = form
      this.deleteFactModal.show = true
      this.deleteFactModal.fact = fact
    },
    closeFactDeleteModal() {
      this.deleteFactModal.representationType = undefined
      this.deleteFactModal.form = undefined
      this.deleteFactModal.show = false
      this.deleteFactModal.fact = undefined
    },
    deleteFact() {
      if (this.deleteFactModal.fact) {
        const existingFactIndex = this.formData.fact_rules.findIndex(
          (item) => item.jar_fact_sub_type_id == this.deleteFactModal.fact.jar_fact_sub_type_id
            && item.representation_type === this.deleteFactModal.fact.representation_type
            && item.jar_form_code == this.deleteFactModal.fact.jar_form_code
        );

        if (existingFactIndex !== -1) {
          this.formData.fact_rules.splice(existingFactIndex, 1);
        }
      }
      this.closeFactDeleteModal()
    },
  },
}
</script>
<style lang="scss">
.ck-editor__editable {
  min-height: 5000px;
}
</style>
